<template>
  <div class="page-content" style="padding-top: 4rem">
    <div class="container-fluid">
      <InfoCard :infoData="this.infoDetails" :loading="this.loading" />
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card" id="orderList">
          <div class="card-header border-0">
            <div class="d-flex align-items-center" style="text-align: left">
              <h5 class="card-title mb-0 flex-grow-1">OPERATORS</h5>
              <div class="flex-shrink-0">
                <button
                  type="button"
                  class="btn btn-success add-btn"
                  @click="addOperator()"
                >
                  <i class="ri-add-line align-bottom me-1"></i> Add Operator
                </button>
                &nbsp;&nbsp;
                <button type="button" @click="expOprNow()" class="btn btn-info">
                  <i class="ri-download-line align-bottom me-1"></i> Export
                </button>
              </div>
            </div>
          </div>

          <div
            class="card-body border border-dashed border-end-0 border-start-0"
          >
            <form>
              <div class="row g-3">
                <div class="col-xxl-5 col-sm-6">
                  <div class="search-box">
                    <input
                      type="text"
                      class="form-control search"
                      v-model="search_key"
                      @keydown.enter.prevent
                      @input="fetchList(0)"
                      placeholder="Enter Phone Number"
                    />
                    <i class="ri-search-line search-icon"></i>
                  </div>
                </div>
                <div class="col-xxl-2 col-sm-4">
                  <div>
                    <select
                      class="form-control"
                      v-model="search_status"
                      v-on:change="fetchList(1)"
                      name="choices-single-default"
                      id="idStatus"
                    >
                      <option value="" selected>Filters</option>
                      <option
                        v-for="(option, index) in filterOptions"
                        :key="index"
                        :value="option.value"
                      >
                        {{ option.label }}
                      </option>
                    </select>
                  </div>
                </div>
                <div
                  class="col-xxl-2 col-sm-4"
                  v-if="ldata != null && ldata.role == 'superadmin'"
                >
                  <div>
                    <select
                      class="form-control"
                      v-model="search_sort_by"
                      v-on:change="fetchList(1)"
                      name="choices-single-default"
                      id="idStatus"
                    >
                      <option value="">Sort By</option>
                      <option
                        v-for="(option, index) in sortOptions"
                        :key="index"
                        :value="option.value"
                      >
                        {{ option.label }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="card-body pt-0">
            <div>
              <br />
              <br />
              <div class="table-responsive table-card mb-1">
                <div class="noresult" v-if="loading">
                  <rb-loading-table />
                </div>
                <div v-else>
                  <rb-data-table
                    title="operator"
                    :ldata="ldata"
                    :headers="headers"
                    :tableData="formattedOperators"
                    @edit="updateOperator"
                    @delete="openDeleteDialog"
                  />
                </div>
                <div class="d-flex justify-content-end pr-4" v-if="!loading">
                  <div class="me-3">
                    <select
                      class="form-select w-auto"
                      v-model="limitProxy"
                      @change="fetchList(1)"
                    >
                      <template
                        v-for="(role, index) in paginationOptions"
                        :key="index"
                      >
                        <option :value="role">{{ role }}</option>
                      </template>
                    </select>
                  </div>
                  <div
                    class="pagination-wrap hstack gap-2"
                    style="display: flex"
                  >
                    <a
                      class="page-item pagination-prev px-4"
                      v-if="pageNo > 1"
                      @click="fetchList(pageNo - 1)"
                      href="javascript:void(0)"
                    >
                      <i class="ri-arrow-left-line"></i>
                    </a>
                    <ul
                      class="pagination listjs-pagination mb-0"
                      v-if="operators.length > 0"
                    >
                      <li class="active">
                        <a class="page" href="javascript:void(0)">{{
                          pageNo
                        }}</a>
                      </li>
                      <li>
                        <a
                          v-if="operators.length >= limit"
                          class="page"
                          href="javascript:void(0)"
                          @click="fetchList(pageNo + 1)"
                          >{{ pageNo + 1 }}</a
                        >
                      </li>
                    </ul>
                    <a
                      v-if="operators.length >= limit"
                      class="page-item pagination-next px-4"
                      href="javascript:void(0)"
                      @click="fetchList(pageNo + 1)"
                    >
                      <i class="ri-arrow-right-line"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <DeleteDialog
      ref="deleteDialog"
      :cancel-text="'No'"
      :confirm-text="'Yes'"
      @confirm="deleteOperator"
    />
    <ToastNotification ref="toast" />
    <LoaderLoading v-if="overallLoading" />
  </div>
</template>

<script>
import {
  getAllOperators,
  getOperatorById,
  deleteOperator,
} from "@/apis/operator";
import listMixin from "@/mixins/listMixin";
import { operatorInfoDetails } from "@/constants/infodetails";
import { operatorHeaders } from "@/constants/headers";
import { operatorFilterOptions } from "@/constants/filter";
import { operatorSortOptions } from "@/constants/sort";

export default {
  name: "operatorsList",
  mixins: [listMixin],

  data() {
    return {
      operators: [],

      search_key: "",
      search_status: "",
      search_sort_by: "",

      sortOptions: operatorSortOptions,
      headers: operatorHeaders,
      infoDetails: operatorInfoDetails,
      filterOptions: operatorFilterOptions,
    };
  },
  methods: {
    async expOprNow() {
      const fields = [
        "spec_id",
        "created_at",
        "name",
        "mobile",
        "email",
        "onbordingProgress",
        "fleetSize",
        "revenue",
        "bookings",
      ];
      this.$exportCsv(this.formattedOperators, "Operator.csv", fields);
    },
    async fetchList(pageNo) {
      const response = await this.fetch(pageNo, getAllOperators, {
        phone_number: this.search_key,
        status: this.search_status,
        sort_by: this.search_sort_by,
      });

      this.operators = response.data;
      this.infoDetails[0].count = response?.active_operators || 0;
      this.infoDetails[1].count = response?.in_complete_operators || 0;
      this.infoDetails[2].count = response?.total_active_buses || 0;

      this.stopLoading();
    },

    addOperator() {
      this.add("/add_operator/add");
    },

    async deleteOperator(operator) {
      await this.delete(deleteOperator, operator.spec_id);
    },

    async updateOperator(operator) {
      await this.update(
        getOperatorById,
        operator.spec_id,
        "/add_operator",
        "phone_number"
      );
    },
  },

  computed: {
    formattedOperators() {
      return this.operators.map((operator) => ({
        id: operator.id,
        spec_id: operator.operator_id,
        name: operator.name || "N/A",
        created_at: operator.created_at
          ? new Date(operator.created_at).toLocaleString()
          : "N/A",
        mobile: operator.phone_number || "N/A",
        email: operator.email,
        fleetSize: operator.fleet_size || 0,
        revenue: operator.revenue || 0,
        bookings: operator.total_booking || 0,
        onbordingProgress: operator.onboarding_progress || "0",
        role: operator.role || "Operator",
        status: operator.is_active ? "Active" : "In Active",
      }));
    },
  },
};
</script>
